"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = (0, tslib_1.__importStar)(require("react"));
var injectIntl_1 = require("./injectIntl");
var utils_1 = require("../utils");
function useIntl() {
    var intl = React.useContext(injectIntl_1.Context);
    (0, utils_1.invariantIntlContext)(intl);
    return intl;
}
exports.default = useIntl;
